// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M19 3H5.00002C3.89546 3 3.00003 3.89542 3.00002 4.99998C3.00001 6.10456 3.89544 7 5.00002 7H18M3 7V6M3 7H19C20.1045 7 21 7.89543 21 9V19C21 20.1046 20.1045 21 19 21H3V7ZM16 14H17","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"wallet"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19 7H3V21H19C20.1045 21 21 20.1046 21 19V9C21 7.89543 20.1045 7 19 7Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 3H5.00002C3.89546 3 3.00003 3.89542 3.00002 4.99998C3.00001 6.10456 3.89544 7 5.00002 7H18M3 7V6M3 7H19C20.1045 7 21 7.89543 21 9V19C21 20.1046 20.1045 21 19 21H3V7ZM16 14H17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WalletIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wallet',
    ref,
    icon: element,
  },
));

WalletIcon.displayName = 'WalletIcon';

export default WalletIcon;
